import { BrandHeritageContentType } from '../../../types/content';

export function TimePeriod(props: BrandHeritageContentType) {
  const {
    imageDescription,
    isReversed,
    imageTitle,
    quote,
    quotee,
    src,
    timePeriod
  } = props;

  const reversed = isReversed ? 'flex-row-reverse' : '';

  return (
    <div
      className={`flex justify-center items-center w-full px-3 ${reversed}`}
      id={timePeriod}
    >
      <div className="flex flex-col justify-center items-center h-128 w-96 text-center font-MuseoSans100 text-header6 font-extralight p-3">
        &quot;{quote}&quot;
        <p className="font-MuseoSans100 text-header6 font-extralight">
          {quotee}
        </p>
      </div>
      <div className="time-period-container flex justify-center items-center h-128 w-40 font-ChronicleDisplaySemibold relative p-3">
        <p className="border border-black p-4 text-header5 bg-white">
          {timePeriod}
        </p>
      </div>
      <div className="block h-full w-96 border border-black p-3">
        <img alt="time-period-image" src={src} />
        <div>
          <h6 className="text-body font-MuseoSans100 mt-3">{imageTitle}</h6>
          <p className="text-subtitle font-extralight">{imageDescription}</p>
        </div>
      </div>
    </div>
  );
}

export default TimePeriod;
